import {JsonProperty} from '@dhkatz/json-ts';
import {TitleItem} from '../../../globals/api/data/title-item';

export class MainCategoryResponse extends TitleItem {

  @JsonProperty('image')
  private _image: string;

  @JsonProperty('retinaImage')
  private _retinaImage: string;

  public constructor() {
    super();
    this._image = undefined;
    this._retinaImage = undefined;
  }

  public get image(): string {
    return this._image;
  }

  public get retinaImage(): string {
    return this._retinaImage;
  }
}
